module.exports = __webpack_public_path__ + "static/ebaybanner-9e1feffb172944c9b9e54fcc90b0d35d.jpg";